var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 190,
    viewBox: "0 0 181 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3502_24030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.337 109.263H120.29C120.29 79.3663 96.0273 55.0343 66.2159 55.0343C36.4044 55.0343 12.1417 79.3663 12.1417 109.263H10.0942C10.0942 78.237 35.2783 52.981 66.2159 52.981C97.1534 52.981 122.337 78.237 122.337 109.263Z",
    fill: "#D3FF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.49 108.236H6.94098C5.07777 108.236 3.3374 108.955 2.00654 110.29C0.71662 111.624 0 113.37 0 115.218C0 119.057 3.11218 122.178 6.94098 122.178H125.49C127.374 122.178 129.115 121.46 130.404 120.125C131.735 118.811 132.452 117.066 132.452 115.218C132.452 111.378 129.319 108.236 125.49 108.236ZM128.951 118.688C128.05 119.612 126.821 120.125 125.49 120.125H6.94098C4.2383 120.125 2.04749 117.928 2.04749 115.218C2.04749 113.904 2.55936 112.672 3.46025 111.727C4.4021 110.803 5.63059 110.29 6.94098 110.29H125.49C128.193 110.29 130.404 112.507 130.404 115.218C130.404 116.511 129.893 117.743 128.951 118.688Z",
    fill: "#D3FF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7539 120.426L10.3062 121.878L23.0178 134.626L24.4656 133.174L11.7539 120.426Z",
    fill: "#D3FF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.996 120.427L107.98 133.48L109.428 134.932L122.443 121.879L120.996 120.427Z",
    fill: "#D3FF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2157 190C42.2396 190 22.7476 170.453 22.7476 146.408V120.249H109.684V146.408C109.684 170.453 90.1918 190 66.2157 190ZM24.795 122.322V146.429C24.795 169.323 43.3862 187.968 66.2157 187.968C89.0452 187.968 107.636 169.323 107.636 146.429V122.322H24.795Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3502_24030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.212 1H97.3635C91.088 1 86 6.08798 86 12.3635V39.4293C86 45.7048 91.088 50.7928 97.3635 50.7928H115.477L132.788 68.1029L150.098 50.7928H168.212C174.487 50.7928 179.575 45.7048 179.575 39.4293V12.3635C179.575 6.08798 174.487 1 168.212 1Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3502_24030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.254 33.9998C138.064 33.9998 137.87 33.9252 137.726 33.7809L127.219 23.2734C126.925 22.9849 126.925 22.5122 127.219 22.2187C127.512 21.9252 127.98 21.9252 128.273 22.2187L138.786 32.7261C139.079 33.0197 139.079 33.4923 138.786 33.7809C138.642 33.9252 138.448 33.9998 138.258 33.9998H138.254Z",
    fill: "#FA8B94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.746 33.9998C127.557 33.9998 127.363 33.9252 127.219 33.7809C126.925 33.4873 126.925 33.0147 127.219 32.7261L137.726 22.2187C138.02 21.9252 138.492 21.9252 138.781 22.2187C139.069 22.5122 139.074 22.9849 138.781 23.2734L128.273 33.7858C128.129 33.9301 127.935 34.0048 127.746 34.0048V33.9998Z",
    fill: "#FA8B94"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3502_24030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.452,
    height: 137.019,
    fill: "white",
    transform: "translate(0 52.981)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3502_24030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.4019,
    height: 68.9298,
    fill: "white",
    transform: "translate(84.9521)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3502_24030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(127 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.57f47603fc02a72de2adb2148bbca485.svg";
export { ForwardRef as ReactComponent };